import React from 'react';
import {withRouter} from 'react-router-dom';


import VisuelHarmonieCuisine1 from "../visuels/harmonies/cuisine/harmonie-1.jpg";
import VisuelHarmonieCuisine2 from "../visuels/harmonies/cuisine/harmonie-2.jpg";
import VisuelHarmonieCuisine3 from "../visuels/harmonies/cuisine/harmonie-3.jpg";
import VisuelHarmonieCuisine4 from "../visuels/harmonies/cuisine/harmonie-4.jpg";
import VisuelHarmonieCuisine5 from "../visuels/harmonies/cuisine/harmonie-5.jpg";
import VisuelHarmonieCuisine6 from "../visuels/harmonies/cuisine/harmonie-6.jpg";
import VisuelHarmonieCuisine7 from "../visuels/harmonies/cuisine/harmonie-7.jpg";
import VisuelHarmonieCuisine8 from "../visuels/harmonies/cuisine/harmonie-8.jpg";
import VisuelHarmonieCuisine9 from "../visuels/harmonies/cuisine/harmonie-9.jpg";
import VisuelHarmonieCuisine10 from "../visuels/harmonies/cuisine/harmonie-10.jpg";
import VisuelHarmonieCuisine11 from "../visuels/harmonies/cuisine/harmonie-11.jpg";
import VisuelHarmonieCuisine12 from "../visuels/harmonies/cuisine/harmonie-12.jpg";
import VisuelHarmonieCuisine13 from "../visuels/harmonies/cuisine/harmonie-13.jpg";


import VisuelHarmonieSdb1 from "../visuels/harmonies/sdb/Vue-SDB_01-Rose-nenuphar.jpg";
import VisuelHarmonieSdb2 from "../visuels/harmonies/sdb/Vue-SDB_02-Rose-blush.jpg";
import VisuelHarmonieSdb3 from "../visuels/harmonies/sdb/Vue-SDB_03-Roche-Lin-2.jpg";
import VisuelHarmonieSdb4 from "../visuels/harmonies/sdb/Vue-SDB_04-Bleu-profond-2.jpg";
import VisuelHarmonieSdb5 from "../visuels/harmonies/sdb/Vue-SDB_05-Bleu-ecume-bleu-profond-2.jpg";
import VisuelHarmonieSdb6 from "../visuels/harmonies/sdb/Vue-SDB_06-Bleu-Lagon-Bleu-ecume.jpg";
import VisuelHarmonieSdb7 from "../visuels/harmonies/sdb/Vue-SDB_07-Aigue-marine-bleu-ecume-2.jpg";
import VisuelHarmonieSdb8 from "../visuels/harmonies/sdb/Vue-SDB_08-Manganese-bleu-lagon-2.jpg";
import VisuelHarmonieSdb9 from "../visuels/harmonies/sdb/Vue-SDB_09-Gris-perle-manganese.jpg";

import FlecheDroite from "../visuels/fleche-droite.png";
import FlecheGauche from "../visuels/fleche-gauche.png";

class ListeHarmoniesStyliste extends React.Component {

    visuel = "";

    redirectToHome = () => {
        const {history} = this.props;
        if (history) history.push('/');
    };

    redirectToInfo = () => {
        const { history } = this.props;
        if(history) history.push('/infos');
    }


    redirectToBack = () => {
        const {history} = this.props;
        if (history) history.goBack();
    };

    pageAAfficher(page, piece, harmonie) {
        console.log(piece);
        console.log(page);
        if (piece === "sdb") {
            switch (harmonie) {
            case 1:
                this.visuel = VisuelHarmonieSdb1;
                break;
            case 2:
                this.visuel =
                    VisuelHarmonieSdb2;
                break;
            case 3:
                this.visuel =
                    VisuelHarmonieSdb3;
                break;
            case 4:
                this.visuel =
                    VisuelHarmonieSdb4;
                break;

            case 5:
                this.visuel =
                    VisuelHarmonieSdb5;
                break;

            case 6:
                this.visuel =

                    VisuelHarmonieSdb6;
                break;

            case 7:
                this.visuel =

                    VisuelHarmonieSdb7;
                break;

            case 8:
                this.visuel =

                    VisuelHarmonieSdb8;
                break;

            case 9:
                this.visuel =

                    VisuelHarmonieSdb9;
                break;


            default: {
                    alert("L'harmonie n'existe pas !");
                }


            }
        }
        if (piece === "cuisine") {
            switch (harmonie) {
                case 1:
                    this.visuel = VisuelHarmonieCuisine1;
                    break;
                case 2:
                    this.visuel =
                        VisuelHarmonieCuisine2;
                    break;
                case 3:
                    this.visuel =
                        VisuelHarmonieCuisine3;
                    break;
                case 4:
                    this.visuel =
                        VisuelHarmonieCuisine4;
                    break;

                case 5:
                    this.visuel =
                        VisuelHarmonieCuisine5;
                    break;

                case 6:
                    this.visuel =

                        VisuelHarmonieCuisine6;
                    break;

                case 7:
                    this.visuel =

                        VisuelHarmonieCuisine7;
                    break;

                case 8:
                    this.visuel =

                        VisuelHarmonieCuisine8;
                    break;

                case 9:
                    this.visuel =

                        VisuelHarmonieCuisine9;
                    break;

                case 10:
                    this.visuel =

                        VisuelHarmonieCuisine10;
                    break;

                case 11:
                    this.visuel =

                        VisuelHarmonieCuisine11;
                    break;

                case 12:
                    this.visuel =

                        VisuelHarmonieCuisine12;
                    break;

                case 13:
                    this.visuel =

                        VisuelHarmonieCuisine13;
                    break;
                default: {
                    alert("L'harmonie n'existe pas !");
                }


            }
        }
    }
    maxCuisine = 13;
    maxSalleDeBains = 9;


    redirectToNext = () => {
        const { history } = this.props;
        const {params} = this.props.match;
        var numero = params.id * 1;

            numero++;
            if(this.piece == 'cuisine')
            {
                if(numero > this.maxCuisine)
                {
                    numero = 1;
                }
            }

            if(this.piece == 'sdb')
            {
                if(numero > this.maxSalleDeBains)
                {
                    numero = 1;
                }
            }
        if(history)
        {
            history.push('/pieces/' + this.piece + '/styliste/harmonie/' + numero );
        }
    };

    redirectToPrev = () => {
        const { history } = this.props;
        const {params} = this.props.match;
        var numero = params.id *1;

            numero--;
            if(this.piece == 'cuisine')
            {
                if(numero < 1)
                {
                    numero = this.maxCuisine;
                }
            }

            if(this.piece == 'sdb')
            {
                if(numero < 1)
                {
                    numero = this.maxSalleDeBains;
                }
            }

        if(history)
        {
            history.push('/pieces/' + this.piece + '/styliste/harmonie/' + numero );
        }
    };

    render() {
        const {params} = this.props.match;
        this.piece = params.piece;
        if ("page" in params)
            this.page = params.page * 1;
        this.pageAAfficher(this.page, this.piece, params.id * 1);
        return (
            <div>
                <img src={this.visuel} alt="Harmonies rouge" style={{width: 1280}} useMap="#image-map"/>
                <img src={FlecheDroite} className="harmonie-fleche-droite" onClick={this.redirectToNext} />
                <img src={FlecheGauche} className="harmonie-fleche-gauche" onClick={this.redirectToPrev}/>

                <map name="image-map">
                    <area onClick={this.redirectToInfo} alt="" title="J'ai termine" coords="75,1200,300,900" shape="rect"/>
                    <area onClick={this.redirectToHome} alt="" title="Accueil" coords="850,1200,950,900" shape="rect"/>
                    <area onClick={this.redirectToBack} alt="" title="Page précédente" coords="970,1200,1090,900" shape="rect"/>
                    <area onClick={this.redirectToInfo} alt="" title="Infos" coords="1100,1200,1250,900" shape="rect"/>
                </map>
            </div>);
    }

}

export default withRouter(ListeHarmoniesStyliste);